/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/OrganizationIndexSearchResultExtended'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./OrganizationIndexSearchResultExtended'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.OrganizationIndexSearchResultExtended);
  }
}(this, function(ApiClient, OrganizationIndexSearchResultExtended) {
  'use strict';




  /**
   * The OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport model module.
   * @module model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport</code>.
   * @alias module:model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport} obj Optional instance to populate.
   * @return {module:model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport} The populated <code>OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('List')) {
        obj['List'] = ApiClient.convertToType(data['List'], [OrganizationIndexSearchResultExtended]);
      }
      if (data.hasOwnProperty('PageNumber')) {
        obj['PageNumber'] = ApiClient.convertToType(data['PageNumber'], 'Integer');
      }
      if (data.hasOwnProperty('ItemsPerPage')) {
        obj['ItemsPerPage'] = ApiClient.convertToType(data['ItemsPerPage'], 'Integer');
      }
      if (data.hasOwnProperty('TotalFound')) {
        obj['TotalFound'] = ApiClient.convertToType(data['TotalFound'], 'Integer');
      }
      if (data.hasOwnProperty('SearchQuery')) {
        obj['SearchQuery'] = ApiClient.convertToType(data['SearchQuery'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/OrganizationIndexSearchResultExtended>} List
   */
  exports.prototype['List'] = undefined;
  /**
   * @member {Integer} PageNumber
   * @default 0
   */
  exports.prototype['PageNumber'] = 0;
  /**
   * @member {Integer} ItemsPerPage
   * @default 0
   */
  exports.prototype['ItemsPerPage'] = 0;
  /**
   * @member {Integer} TotalFound
   * @default 0
   */
  exports.prototype['TotalFound'] = 0;
  /**
   * @member {String} SearchQuery
   * @default ''
   */
  exports.prototype['SearchQuery'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


